import { number } from "framer-motion";
import { Car } from "../types/car.types";

const isValidIndianNumberPlate = (plate: string) => {
  const regex = /^[A-Z]{2}[0-9]{1,2}[A-Z0-9]{0,2}[0-9]{1,4}$/i;
  return regex.test(plate);
};

const isValidYear = (str: string) => {
  const year = Number(str);
  return /^\d{4}$/.test(str) && !isNaN(year);
};

const isValidNumber = (str: string | number) => {
  if (str === null || str === undefined) return false;
  const value = typeof str === "number" ? str.toString() : str.trim();
  if (value === "") return false;
  return !isNaN(Number(value));
};

const validateForm = (step: number, data: Car) => {
  const err: Record<string, string> = {};
  if (step === 1) {
    if (!data.number) {
      err.number = "Car number required";
    } else {
      if (!isValidIndianNumberPlate(data.number)) {
        err.number = "Enter a valid number";
      }
    }
    if (!data.brand) err.brand = "Brand required";
    if (!data.model) err.model = "Model required";
    if (!data.carType) {
      err.carType = "Car type required";
    } else {
      if (
        data.carType !== "sedan" &&
        data.carType !== "suv" &&
        data.carType !== "hatchback"
      ) {
        err.carType = "Car type must be sedan, suv or hatchback";
      }
    }
  }

  if (step === 2) {
    if (!data.kms) {
      err.kms = "Dashboard kms required";
    } else {
      if (!isValidNumber(data.kms)) {
        err.kms = "Enter the kilometers";
      }
    }
    if (!data.insuranceExpiry)
      err.insuranceExpiry = "Insurance expiry date is required";
    if (!data.fuelType) err.fuelType = "Fuel type is required";
    if (!data.year) {
      err.year = "Registration year is required";
    } else {
      if (!isValidYear(data.year)) {
        err.year = "Enter a valid year";
      }
    }
  }

  if (step === 3) {
    if (!data.lastServiceDate)
      err.lastServiceDate = "Last service date is required";
    if (!data.lastServiceKms) {
      err.lastServiceKms = "Last service kms is required";
    } else {
      if (!isValidNumber(data.lastServiceKms)) {
        err.lastServiceKms = "Enter kilometers";
      }
    }
    if (!data.driveFrequency)
      err.driveFrequency = "Drive frequency is required";
  }
  return err;
};

export { isValidIndianNumberPlate, isValidYear, isValidNumber, validateForm };
